
(function (angular) {
    var STATE_NAME = 'app.cart.checkout.process.address';
    angular.module('mobilezuz').config(['$stateProvider', 'PAGE_ACCESS', function ($stateProvider) {
        $stateProvider.state(STATE_NAME, {
            url: '/address?addressDetails',
            checkoutViewOriginalIndex: 1,
            checkoutViewIndex: 1,
            views: {
                'checkoutProcess': {
                    templateUrl: 'views/checkout/process/address.html',
                    controller: 'CheckoutAddressCtrl as checkoutAddressCtrl'
                }
            }
        });
    }]).controller('CheckoutAddressCtrl', [
        '$scope', '$rootScope', '$filter', '$q', '$timeout', 'Config', 'Api', 'User', 'ShippingTermsPopup', 'Retailer',
        'SpDeliveryAreasService', 'mDesign', 'branchArea', 'SP_SERVICES', 'CITY_TYPES', 'HOUSE_ENTRIES',
        'DELIVERY_AREA_METHODS_PRECISION', 'PHONE_TYPES', 'Util', 'DataLayer', 'Cart', 'mDesign', 'AddressService', '$state', 'GOOGLE_MAP_ADDRESS_TYPES',
        function ($scope, $rootScope, $filter, $q, $timeout, Config, Api, User, ShippingTermsPopup, Retailer,
                  SpDeliveryAreasService, mDesign, branchArea, SP_SERVICES, CITY_TYPES, HOUSE_ENTRIES,
                  DELIVERY_AREA_METHODS_PRECISION, PHONE_TYPES, util, DataLayer, Cart, mDesign, AddressService, $state, GOOGLE_MAP_ADDRESS_TYPES) {
            var checkoutProcessCtrl = $scope.checkoutProcessCtrl,
                checkoutAddressCtrl = this,
                _translate = $filter('translate'),
                _firstTimeInAddressPage = !checkoutProcessCtrl.addressDetails,
                _getCitiesPromise,
                _cityChangeTimeout,
                _houseNumberRegExp = new RegExp(/^[0-9]+$/),
                _wasText1HouseNumberShown = false,
                _listeners = [],
                _addressComponents = ['city', 'text1'],
                _previousFullDeliveryAddress = localStorage.getItem('previousFullDeliveryAddress') ? JSON.parse(localStorage.getItem('previousFullDeliveryAddress')) : null,
                _ADDRESS_TYPE_MAP = {
                    city: 'city',
                    text1: 'address'
                };

            if (!checkoutProcessCtrl.isAddressFirst && !checkoutProcessCtrl.timesDetails) {
                return checkoutProcessCtrl.goToState('app.cart.checkout.process.times', 500);
            }

            checkoutProcessCtrl.nextView = nextView;
            checkoutProcessCtrl.previousView = previousView;
            checkoutProcessCtrl.validateView = validateView;
            checkoutProcessCtrl.getCityAutoCompleteOptions = getCityAutoCompleteOptions;
            checkoutProcessCtrl.getStreetAutoCompleteOptions = getStreetAutoCompleteOptions;
            checkoutProcessCtrl.onCityChange = onCityChange;
            checkoutProcessCtrl.onCityBlur = onCityBlur;
            checkoutProcessCtrl.onCityChosen = onCityChosen;
            checkoutProcessCtrl.onAddressChange = onAddressChange;
            checkoutProcessCtrl.onAddressBlur = onAddressBlur;
            checkoutProcessCtrl.onAddressChosen = onAddressChosen;
            checkoutProcessCtrl.getAddressAutoCompleteOptions = getAddressAutoCompleteOptions;
            checkoutProcessCtrl.extractAddressField = extractAddressField;
            checkoutProcessCtrl.isExistedInSuggestions = isExistedInSuggestions;
            checkoutProcessCtrl.onAddressInputKeydown = onAddressInputKeydown;
            checkoutProcessCtrl.openGoogleMapDialog = openGoogleMapDialog;
            checkoutProcessCtrl.onCountryBlur = onCountryBlur;

            checkoutAddressCtrl.validateText1HouseNumber = validateText1HouseNumber;
            checkoutAddressCtrl.backupAddress = {};
            checkoutAddressCtrl.editUnrecognizedAddress = editUnrecognizedAddress;

            checkoutProcessCtrl.addressDetails = checkoutProcessCtrl.addressDetails || {};
            checkoutProcessCtrl.suggestedCities = [];
            checkoutProcessCtrl.suggestedAddresses = [];
            checkoutProcessCtrl.isAddressVerificationEnabled = false;
            checkoutProcessCtrl.addressVerificationText = Config.retailer.settings.addressVerificationText ? JSON.parse(Config.retailer.settings.addressVerificationText) : {};
            checkoutProcessCtrl.formErrorCtrl = {
                city: false,
                text1: false
            };
            checkoutProcessCtrl.isRunAddressAutoComplete = true;
            _setOrInitValueForAddressField('isShowEditAddress', checkoutProcessCtrl.addressDetails.isShowEditAddress, false);
            _setOrInitValueForAddressField('isSuggestedAddress', checkoutProcessCtrl.addressDetails.isSuggestedAddress, false);
            _setOrInitValueForAddressField('hasHouseNumberAndRoute', checkoutProcessCtrl.addressDetails.hasHouseNumberAndRoute, true);
            _setOrInitValueForAddressField('isDisabledAddressField', checkoutProcessCtrl.addressDetails.isDisabledAddressField, false);

            Config.checkoutData.state = STATE_NAME;
            Config.checkoutData.addressDetails = checkoutProcessCtrl.addressDetails;

            ShippingTermsPopup.showWithRedirect('app.cart'); 

            if (_firstTimeInAddressPage) {
                User.getUserSettings().then(function (user) {
                    if (!user) return;

                    var address = user.addresses && user.addresses.length ? user.addresses[0] : {},
                        userPhone = {};
                    angular.forEach(user.phones, function (phone) {
                        if (phone.typeVal === PHONE_TYPES.MOBILE) {
                            userPhone = phone;
                        }
                    });
                    checkoutProcessCtrl.addressDetails.phone = checkoutProcessCtrl.addressDetails.phone || userPhone.phoneNumber;
                    checkoutProcessCtrl.addressDetails.addressId = checkoutProcessCtrl.addressDetails.addressId || address.id;
                    checkoutProcessCtrl.addressDetails.text1 = checkoutProcessCtrl.addressDetails.text1 || address.text1 || '';
                    checkoutProcessCtrl.addressDetails.text2 = checkoutProcessCtrl.addressDetails.text2 || address.text2 || '';
                    checkoutProcessCtrl.addressDetails.country = checkoutProcessCtrl.addressDetails.country || address.country || '';
                    checkoutProcessCtrl.addressDetails.floor = checkoutProcessCtrl.addressDetails.floor || address.floor || null;
                    checkoutProcessCtrl.addressDetails.apartment = checkoutProcessCtrl.addressDetails.apartment || address.apartment || '';
                    checkoutProcessCtrl.addressDetails.city = checkoutProcessCtrl.addressDetails.city || address.city;
                    checkoutProcessCtrl.addressDetails.street = checkoutProcessCtrl.addressDetails.street || address.street;
                    checkoutProcessCtrl.addressDetails.houseNumber = checkoutProcessCtrl.addressDetails.houseNumber || address.houseNumber;
                    checkoutProcessCtrl.addressDetails.entry = checkoutProcessCtrl.addressDetails.entry || address.entry;
                    checkoutProcessCtrl.addressDetails.friendlyName = checkoutProcessCtrl.addressDetails.friendlyName || ((user.firstName || '') + ' ' + (user.lastName || '')).trim() || address.friendlyName || '';

                    checkoutProcessCtrl.addressDetails.zipCode = checkoutProcessCtrl.addressDetails.zipCode || address.zipCode;

                    try {
                        var addressComponents = JSON.parse(localStorage.getItem('mobileZuzTypedAreaAddressComponents'));
                        var addressFields = util.checkAddressFields(checkoutProcessCtrl.addressDetails);
                        if (addressComponents && !addressFields && !Config.retailer.settings.autocompleteAddressField) {
                            angular.extend(
                                checkoutProcessCtrl.addressDetails,
                                SpDeliveryAreasService.addressComponentsToSpAddress(addressComponents)
                            );
                        }
                    } catch (err) {
                        // In case "mobileZuzTypedAreaAddressComponents" is not array
                    }
                    // Set coord and external place id
                    var isPrevAddr = _isPreviousAddress(checkoutProcessCtrl.addressDetails);
                    if (checkoutProcessCtrl.isDelivery && isPrevAddr) {
                        angular.extend(checkoutProcessCtrl.addressDetails, {
                            geoCoordinates: _previousFullDeliveryAddress.geoCoordinates,
                            externalPlaceId: _previousFullDeliveryAddress.externalPlaceId
                        });
                    }
                    // Backup address
                    angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
                });
            }

            Retailer.getRetailerSettings().then(function (response) {
                if (checkoutProcessCtrl.isDelivery) {
                    checkoutProcessCtrl.streetIsRequire = response.deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                    checkoutProcessCtrl.deliveryAreaMethod = response.deliveryAreaMethod;
                    if (checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                        getCityAutoCompleteOptions().then(function (citiesList) {
                            if (!citiesList) {
                                return;
                            }

                            var foundCity = _findCityAndSetIsStreetRequired(citiesList);
                            if (!foundCity) {
                                delete checkoutProcessCtrl.addressDetails.city;
                            }
                        });
                    }
                    // For feature address verification
                    var isEnable = Config.retailer.settings.isAddressVerificationEnabled && Config.retailer.settings.isAddressVerificationEnabled === 'true';
                    var isUseGoogleMapApi = [SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON, SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS].includes(checkoutProcessCtrl.deliveryAreaMethod);
                    checkoutProcessCtrl.isAddressVerificationEnabled = isEnable && isUseGoogleMapApi;
                }
                checkoutProcessCtrl.enableFloorApartment = response.enableFloorApartment;
            });

            if (!checkoutProcessCtrl.isDelivery && checkoutProcessCtrl.areas && checkoutProcessCtrl.areas.length) {
                checkoutProcessCtrl.setAreaByConfigAreaId();
            }

            _init()

            function _init() {
                getAddressFromMap();
                if (Config.retailer.settings.enableDefaultCountry) {
                    _addressComponents.push('country');
                }
                if (_previousFullDeliveryAddress && _previousFullDeliveryAddress.geoCoordinates) {
                    _previousFullDeliveryAddress.geoCoordinates = {
                        lat: isNaN(_previousFullDeliveryAddress.geoCoordinates.lat) ? null : +_previousFullDeliveryAddress.geoCoordinates.lat,
                        lng: isNaN(_previousFullDeliveryAddress.geoCoordinates.lng) ? null : +_previousFullDeliveryAddress.geoCoordinates.lng,
                    }
                }
            }

            function getAddressFromMap() {
                var adrsDetailsParams = $state.params.addressDetails;
                if (adrsDetailsParams) {
                    _handleSelectedGoogleMapAddress(JSON.parse(adrsDetailsParams));
                }
            }

            function getCityAutoCompleteOptions() {
                var city = extractAddressField('city');
                if (!city) {
                    return $q.resolve([]);
                }

                var citiesDefer = $q.defer();
                _getCitiesPromise = citiesDefer.promise;
                var getRequestFunc = checkoutProcessCtrl.isAddressVerificationEnabled ? _getCitiesFromGoogleMapApi : _getInternalCities;

                return getRequestFunc(city).then(function (data) {
                    checkoutProcessCtrl.suggestedCities = data.cities;
                    citiesDefer.resolve(data.cities);
                    return data.cities;
                }).catch(function (err) {
                    citiesDefer.reject(err);
                    return _getCitiesPromise;
                });
            }

            function getStreetAutoCompleteOptions() {
                if (!checkoutProcessCtrl.addressDetails.street) {
                    return $q.resolve([]);
                }

                return $q.resolve(_getCitiesPromise).then(function(cities) {
                    if (!cities) {
                        return $q.reject('no cities');
                    }

                    var cityId;
                    angular.forEach(cities, function (city) {
                        if (city.name === checkoutProcessCtrl.addressDetails.city) {
                            cityId = city.id;
                        }
                    });

                    if (!cityId) {
                        return $q.reject('city not found');
                    }

                    return cityId;
                }).then(function(cityId) {
                    return Api.request({
                        method: 'GET',
                        url: '/v2/addresses/streets',
                        params: {
                            term: checkoutProcessCtrl.addressDetails.street,
                            cityId: cityId,
                            size: 8
                        }
                    });
                }).then(function (data) {
                    var streetsName = [];

                    angular.forEach(data.streets, function (street) {
                        streetsName.push(street.name);
                    });

                    return streetsName;
                });
                // if (!checkoutProcessCtrl.addressDetails.street) return;
                // var cityId;
                // angular.forEach(checkoutProcessCtrl.citiesList, function (city) {
                //     if (city.name === checkoutProcessCtrl.addressDetails.city) {
                //         cityId = city.id;
                //     }
                // });
                //
                // if (!cityId) return;
                //
                // return Api.request({
                //     method: 'GET',
                //     url: '/v2/addresses/streets',
                //     params: {
                //         term: checkoutProcessCtrl.addressDetails.street,
                //         cityId: cityId,
                //         size: 4
                //     }
                // }).then(function (data) {
                //     var streetNames = [];
                //
                //     angular.forEach(data.streets, function (street) {
                //         streetNames.push(street.name);
                //     });
                //
                //     return streetNames;
                // });
            }

            function onCityChange() {
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['city'],
                        isSuggestedAddress: false
                    });
                    return;
                }
                if (_cityChangeTimeout) {
                    $timeout.cancel(_cityChangeTimeout);
                    return _cityChangeTimeout = null;
                }

                $timeout(function() {
                    $rootScope.$emit('checkout.city.change');
                    _cityChangeTimeout = null;

                    if (_getCitiesPromise) {
                        _getCitiesPromise.then(function(cities) {
                            _findCityAndSetIsStreetRequired(cities);
                        });
                    }
                }, 100);
            }

            function _findCityAndSetIsStreetRequired(cities) {
                for (var i = 0; i < cities.length; i++) {
                    if (cities[i].name === checkoutProcessCtrl.addressDetails.city) {
                        checkoutProcessCtrl.streetIsRequire = checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE && cities[i].type === CITY_TYPES.MULTIPLE_ZIP_CODES;
                        return cities[i];
                    }
                }
            }

            function nextView() {
                checkoutProcessCtrl.addressDetails.entry = _getEntryValue(checkoutProcessCtrl.addressDetails.entry);
                if (checkoutProcessCtrl.isAddressFirst) {
                    return checkoutProcessCtrl.goToState('app.cart.checkout.process.times');
                }
                checkoutProcessCtrl.goToState('app.cart.checkout.process.' + (checkoutProcessCtrl.isPaymentLast() ? 'summary' : 'payment'));
            }

            function previousView() {
                if (checkoutProcessCtrl.isAddressFirst) return;

                checkoutProcessCtrl.addressDetails.entry = _getEntryValue(checkoutProcessCtrl.addressDetails.entry);
                return checkoutProcessCtrl.goToState('app.cart.checkout.process.times');
            }

            //set "None" value as null
            function _getEntryValue(entry) {
                if (entry === _translate(HOUSE_ENTRIES[0])) {
                    return null;
                }
                return entry;
            }

            function validatePhone () {
                if(checkoutProcessCtrl.mobilePhone.customValidated){
                    checkoutProcessCtrl.addressDetails.phone = [
                        checkoutProcessCtrl.mobilePhone.areaCode ? checkoutProcessCtrl.mobilePhone.areaCode.toString() : '',
                        checkoutProcessCtrl.mobilePhone.customPhoneNumber ? checkoutProcessCtrl.mobilePhone.customPhoneNumber.toString() : ''
                    ].join('');
                }
                return Api.request({
                    method: 'POST',
                    url: '/v1/retailers/:rid/phone-number/is-valid',
                    data: {
                        phoneNumber: checkoutProcessCtrl.addressDetails.phone,
                        phoneId: checkoutProcessCtrl.mobilePhone.id,
                        countryCode: checkoutProcessCtrl.mobilePhone.countryCode,
                        areaCode: checkoutProcessCtrl.mobilePhone.areaCode,
                        customValidated: checkoutProcessCtrl.mobilePhone.customValidated,
                        customPhoneNumber: checkoutProcessCtrl.mobilePhone.customPhoneNumber
                    }
                });
            }

            function _validateAddressFields() {
                return validatePhone().then(function (isValidPhone) {
                    if(!isValidPhone) {
                        return mDesign.alert('{{(\'Phone number is not valid.\' | translate)}}');
                    }
                    var checkoutForm = document.querySelector('#address_form'),
                        form = angular.element(checkoutForm).data('$formController');

                    if(!checkoutForm){
                        return
                    }

                    if (!checkoutProcessCtrl.addressDetails.friendlyName || !checkoutProcessCtrl.addressDetails.friendlyName.trim()) {
                        return {selector: angular.element(checkoutForm.querySelector('#friendly_name'))};
                    }
                    if (!checkoutProcessCtrl.addressDetails.phone || !isValidPhone) {
                        return {selector: angular.element(checkoutForm.querySelector('#phone_number')), isPhoneValid: isValidPhone};
                    }
                    if (checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON ||
                        checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS
                    ) {
                        if (checkoutProcessCtrl.streetIsRequire && (!checkoutProcessCtrl.addressDetails.geoCoordinates && (!checkoutProcessCtrl.addressDetails.text1 ||
                            !checkoutProcessCtrl.addressDetails.text1.trim()))) {
                            return {selector: angular.element(checkoutForm.querySelector('#address_text_input'))};
                        }
                    }
                    if (!checkoutProcessCtrl.addressDetails.city || !checkoutProcessCtrl.addressDetails.city.trim() ||
                        (form['city'] && form['city'].$invalid)) {
                        return {selector: angular.element(checkoutForm.querySelector('#city_input'))};
                    }
                    if (checkoutProcessCtrl.streetIsRequire && (
                        checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE ||
                        checkoutProcessCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY
                    )) {
                        if (!checkoutProcessCtrl.addressDetails.street || !checkoutProcessCtrl.addressDetails.street.trim() ||
                            (form['street'] && form['street'].$invalid)) {
                            return {selector: angular.element(checkoutForm.querySelector('#street_input'))};
                        }
                        if (!checkoutProcessCtrl.addressDetails.houseNumber) {
                            return {selector: angular.element(checkoutForm.querySelector('#house_number_input'))};
                        }
                    }
                });

            }

            function _validatePickupFields() {
                return validatePhone().then(function (isValidPhone) {
                    if(!isValidPhone) {
                        return mDesign.alert('Phone number is not valid.');
                    }
                    var checkoutForm = document.querySelector('#address_form');
                    if (!checkoutProcessCtrl.addressDetails.friendlyName || !checkoutProcessCtrl.addressDetails.friendlyName.trim()) {
                        return {selector: angular.element(checkoutForm.querySelector('#friendly_name'))};
                    }
                    if (!checkoutProcessCtrl.addressDetails.phone || !isValidPhone) {
                        return {selector: angular.element(checkoutForm.querySelector('#phone_number')), isPhoneValid: isValidPhone};
                    }
                    if (!branchArea) {
                        return {msg: 'Pickup location is required'};
                    }
                    if (checkoutProcessCtrl.areas && checkoutProcessCtrl.areas.length && !(checkoutProcessCtrl.timesDetails && checkoutProcessCtrl.timesDetails.branchArea)) {
                        return {msg: 'Pickup location is required'};
                    }
                });

            }

            function validateView(defer, options) {
                var emptyFieldErr = checkoutProcessCtrl.isDelivery ? _validateAddressFields() : _validatePickupFields();

                return emptyFieldErr.then(function (emptyFieldError) {

                    if (!checkoutProcessCtrl.isDelivery || !!emptyFieldError) {
                        checkoutAddressCtrl.showErrors = true;

                        if (emptyFieldError && (emptyFieldError.selector && emptyFieldError.selector[0] || !emptyFieldError.isPhoneValid)) {
                            setTimeout(function () {
                                var checkoutContainer = document.querySelector('.checkout-container');
                                if (checkoutContainer && emptyFieldError.selector[0]) {
                                    angular.element(checkoutContainer).scrollTop(emptyFieldError.selector[0].offsetTop, 100);
                                }
                            });
                        }

                        return emptyFieldError;
                    }

                    var houseNumberErr = _validateText1HouseNumber();
                    if (houseNumberErr) {
                        return houseNumberErr;
                    }

                    return checkoutProcessCtrl.getDeliveryTimes(defer, options);
                });
            }

            /**
             * Wrapper for _validateText1HouseNumber, to focus on the returned selector
             * @public
             *
             * @returns {Promise<void>|void}
             */
            function validateText1HouseNumber() {
                var promise = _validateText1HouseNumber();
                if (!promise) {
                    return;
                }

                return promise.then(function(err) {
                    if (err.selector) {
                        err.selector.focus();
                    }
                });
            }

            /**
             * Validates the text1 contains a house number
             * Returns a validateView format error after showing the dialog
             * @private
             *
             * @returns {Promise<Object>|void}
             */
            function _validateText1HouseNumber() {
                var deliveryAreaPrecision = $rootScope.config.retailer.deliveryAreaPrecision;
                var isIgnoreValidation = [
                    _wasText1HouseNumberShown,
                    !checkoutProcessCtrl.isDelivery,
                    !checkoutProcessCtrl.addressDetails.text1,
                    checkoutProcessCtrl.addressDetails.isSuggestedAddress,
                    checkoutProcessCtrl.addressDetails.externalPlaceId,
                    checkoutProcessCtrl.addressDetails.geoCoordinates,
                    deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.PRECISE_LOCATION && deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY
                ].some(function (value) {
                    return value;
                });
                if (isIgnoreValidation) {
                    return;
                }

                var splitAddress = checkoutProcessCtrl.addressDetails.text1.split(' '),
                    hasHouseNumber = splitAddress.length >= 2 && splitAddress.some(function(word) {
                        return _houseNumberRegExp.test(word);
                    });
                if (hasHouseNumber) {
                    return;
                }

                _wasText1HouseNumberShown = true;
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/address-number-warning.html',
                    controller: ['$scope', function ($scope) {
                        $scope.hide = mDesign.hide;
                    }]
                }).then(function() {
                    return { selector:  angular.element(document.querySelector('#address_text_input')) };
                });
            }

            function _sendDataLayerEvent() {
                var cartLineProducts = [];
                angular.forEach(Cart.lines, function (line) {
                    if(line && line.product && line.product.id) {
                        line.product.quantity = line.quantity;
                        cartLineProducts.push(line.product);
                    }
                });
                DataLayer.push(DataLayer.EVENTS.CHECKOUT, {products: cartLineProducts, data: {step: 2, option: 'user address'}});
            }

            _listeners.push($rootScope.$on('cart.update.complete', _sendDataLayerEvent));

            util.destroyListeners($scope, _listeners);

            Cart.save();

            function onCityBlur() {
                $timeout(function () {
                    if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                        var city = extractAddressField('city');
                        var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, checkoutProcessCtrl.suggestedCities);
                        if (!isExisted) {
                            $rootScope.$emit('checkout.address.delivery.setFormError', 'city');
                        }
                    }
                    $rootScope.$emit('checkout.details.location.blur', 'city');
                }, 300);
            }

            function onCityChosen($event) {
                var cityComponent = $event && $event.option && $event.option.component;
                if (cityComponent) {
                    angular.extend(checkoutProcessCtrl.addressDetails, cityComponent);
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['city'],
                        isSuggestedAddress: false
                    });
                }
            }

            /**
             * @param {string} field field of address
             * @returns { string | null }
             */
            function extractAddressField(field) {
                return checkoutProcessCtrl.addressDetails[field] ? checkoutProcessCtrl.addressDetails[field].trim() : null;
            }

            /**
             * @param {any} place 
             * @returns {boolean}
             */
            function _isCity(place) {
                return ['locality', 'sublocality', 'neighborhood'].some(function (type) {
                    return place.types.includes(type)
                });
            }

            /**
             * @param {string[]} placeTypes 
             * @returns {boolean}
             */
            function _isAddrSuggestionValid(placeTypes) {
                // The "text1" is the address detail
                var isInvalidPlaceType = [GOOGLE_MAP_ADDRESS_TYPES.ROUTE].some(function (type) {
                    return placeTypes.includes(type);
                });
                return !isInvalidPlaceType;
            }

            function _getInternalCities(cityQuery) {
                return AddressService.getInternalCities(cityQuery);
            }
            
            /**
             * @param {string} cityQuery 
             */
            function _getCitiesFromGoogleMapApi(cityQuery) {
                return AddressService.getAddressesFromGoogleMapApi(cityQuery).then(function (res) {
                    var cities = [];
                    if (res && res.places && res.places.length) {
                        angular.forEach(res.places, function (place) {
                            var isCity = _isCity(place);
                            if (isCity) {
                                cities.push({
                                    name: place.description,
                                    component: {
                                        city: place.structured_formatting.main_text,
                                    },
                                    placeTypes: place.types,
                                    mainValue: place.structured_formatting.main_text
                                });
                            }
                        })
                    }
                    return { cities: cities };
                });
            }

            function getAddressAutoCompleteOptions() {
                var addressQuery = extractAddressField('text1');
                if (!addressQuery || !checkoutProcessCtrl.isRunAddressAutoComplete) {
                    return $q.resolve([]);
                }
                // Call google api
                return AddressService.getAddressesFromGoogleMapApi(addressQuery).then(function (resp) {
                    var addresses = [];
                    if (resp && resp.places && resp.places.length) {
                        angular.forEach(resp.places, function (place) {
                            var CITY_INDEX = 0;
                            var isCity = _isCity(place);
                            if (!isCity) {
                                var item = {
                                    name: place.description, // For displaying options to distinguish
                                    component: {
                                        text1: place.structured_formatting.main_text,
                                        city: place.structured_formatting.secondary_text.split(', ')[CITY_INDEX],
                                        externalPlaceId: place.place_id,
                                    },
                                    placeTypes: place.types
                                }
                                item.mainValue = item.component.text1 + ', ' + item.component.city;
                                addresses.push(item);
                            }
                        });
                    }
                    checkoutProcessCtrl.suggestedAddresses = addresses;
                    return addresses;
                });
            }
            
            function onAddressChange() {
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['text1'],
                        isSuggestedAddress: false
                    });
                }
            }
            
            function onAddressBlur() {
                $timeout(function () {
                    var text1 = extractAddressField('text1');
                    if (text1) {
                        _handleWithExistingText1(text1);
                    } else {
                        _handleWithEmptyText1();
                    }
                }, 300);
            } 
            
            function onAddressChosen($event) {
                var addressComponent = $event && $event.option && $event.option.component;
                if (addressComponent) {
                    angular.extend(checkoutProcessCtrl.addressDetails, addressComponent);
                    checkoutProcessCtrl.isRunAddressAutoComplete = false;
                    $rootScope.$emit('checkout.address.delivery.hideFormError', {
                        hiddenFields: ['city', 'text1'],
                        isSuggestedAddress: false
                    });
                    angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
                }
            }
            
            /**
             * @param {'city' | 'address'} addressType
             * @param {string} value 
             * @param {any[]} suggestions suggestedCities | suggestedAddresses
             * @returns boolean
             */
            function isExistedInSuggestions(addressType, value, suggestions) {
                var isSuggestedAddress = checkoutProcessCtrl.addressDetails.isSuggestedAddress;
                var hasCoordinatesOrPlaceId = checkoutProcessCtrl.addressDetails.geoCoordinates || checkoutProcessCtrl.addressDetails.externalPlaceId;
                if (!value || isSuggestedAddress || hasCoordinatesOrPlaceId) {
                    return true;
                }
                for (var idx = 0; idx < suggestions.length; idx++) {
                    var item = suggestions[idx];
                    switch (addressType) {
                        case _ADDRESS_TYPE_MAP.city: {
                            if (item.mainValue && item.mainValue.toLowerCase() === value.toLowerCase()) {
                                return true;
                            }
                        }
                        case _ADDRESS_TYPE_MAP.text1: {
                            var isValid = _isAddrSuggestionValid(item.placeTypes);
                            var isExisted = item.mainValue && item.mainValue.toLowerCase() === value.toLowerCase();
                            if (isValid && isExisted) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }

            /**
             * @param {any} event 
             * @param {string} errorField address field
             */
            function _setFormErrorEvent(event, errorField) {
                checkoutProcessCtrl.formErrorCtrl[errorField] = true;
            }

            /**
             * @param {any} event 
             * @param {{hiddenFields: string[], isSuggestedAddress: boolean}} emitterData list address field
             */
            function _hideFormErrorEvent(event, emitterData) {
                checkoutProcessCtrl.addressDetails.isSuggestedAddress = emitterData.isSuggestedAddress || false;
                angular.forEach(emitterData.hiddenFields, function (field) {
                    checkoutProcessCtrl.formErrorCtrl[field] = false;
                });
            }

            /**
             * @param {any} event 
             * @param {string} selector element selector
             */
            function _triggerInputBlur(event, selector) {
                var checkoutForm = document.querySelector('#address_form');
                var inputCityElement = checkoutForm && angular.element(checkoutForm.querySelector(selector));
                if (inputCityElement) {
                    inputCityElement.triggerHandler('blur');
                }
                checkoutAddressCtrl.showErrors = true;
            }

            function onAddressInputKeydown() {
                if (checkoutProcessCtrl.isAddressVerificationEnabled) {
                    checkoutProcessCtrl.isRunAddressAutoComplete = true;
                }
            }

            function _handleSelectedGoogleMapAddress(selectedAddress) {
                if (!selectedAddress) {
                    return;
                }
                angular.extend(checkoutProcessCtrl.addressDetails, {
                    text1: selectedAddress.text1,
                    city: selectedAddress.city,
                    country: selectedAddress.country,
                    zipCode: selectedAddress.zipCode,
                    geoCoordinates: {
                        lat: selectedAddress.lat,
                        lng: selectedAddress.lng
                    },
                    externalPlaceId: selectedAddress.placeId,
                    hasHouseNumberAndRoute: selectedAddress.hasHouseNumberAndRoute,
                    isShowEditAddress: !selectedAddress.hasHouseNumberAndRoute,
                    isDisabledAddressField: !selectedAddress.hasHouseNumberAndRoute
                });
                var isSuggestedAddress = selectedAddress.text1 && selectedAddress.city;
                $rootScope.$emit('checkout.address.delivery.hideFormError', {
                    hiddenFields: ['text1', 'city'],
                    isSuggestedAddress: isSuggestedAddress
                });
                angular.extend(checkoutProcessCtrl.addressDetails,{
                    isSuggestedAddress: isSuggestedAddress
                });
                angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
            }

            function openGoogleMapDialog() {
                if (window.cordova) {
                    return goToGoogleMapSelectPage()
                }

                mDesign.dialog({
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/google-map-dialog.html',
                    controller: 'GoogleMapDialogCtrl as googleMapDialogCtrl',
                }).then(_handleSelectedGoogleMapAddress);
            }

            function goToGoogleMapSelectPage(){
              $state.go("app.cart.checkout.process.map", { from: STATE_NAME });
            }

            function _isPreviousAddress(currAddr) {
                var prevAddr = _previousFullDeliveryAddress;
                if (!prevAddr) {
                    return false;
                }
                return _addressComponents.every(function (field) {
                    if (!prevAddr || !prevAddr[field]) {
                        return false;
                    }
                    return prevAddr[field].trim().toLowerCase() === currAddr[field].trim().toLowerCase();
                });
            }

            function _isLocationChanged(field) {
                if (!checkoutAddressCtrl.backupAddress[field] ||  !checkoutProcessCtrl.addressDetails[field]) {
                    return true;
                }
                return checkoutAddressCtrl.backupAddress[field].trim().toLowerCase() !== checkoutProcessCtrl.addressDetails[field].trim().toLowerCase();
            }

            function _handleOnLocationBlur(event, emittedField) {
                // The externalPlaceId is used in setDeliveryTimes function, it's used to fetch all delivery time slots
                var isFieldChanged = _isLocationChanged(emittedField);
                if (isFieldChanged) {
                    angular.extend(checkoutProcessCtrl.addressDetails, {
                        geoCoordinates: null,
                        externalPlaceId: null,
                        hasHouseNumberAndRoute: true,
                        isShowEditAddress: false,
                        isDisabledAddressField: false,
                    });
                    angular.extend(checkoutAddressCtrl.backupAddress, checkoutProcessCtrl.addressDetails);
                }
                // Compare to previous address, if they are match, we will set coordinates and externalPlaceId
                var isPrevAddr = _isPreviousAddress(checkoutProcessCtrl.addressDetails);
                if (isPrevAddr) {
                    var geoCoordinates = checkoutProcessCtrl.addressDetails.geoCoordinates || _previousFullDeliveryAddress.geoCoordinates;
                    var externalPlaceId = checkoutProcessCtrl.addressDetails.externalPlaceId || _previousFullDeliveryAddress.externalPlaceId;
                    angular.extend(checkoutProcessCtrl.addressDetails, {
                        geoCoordinates: geoCoordinates,
                        externalPlaceId: externalPlaceId
                    });
                }
            }

            function onCountryBlur() {
                $timeout(function () {
                    $rootScope.$emit('checkout.details.location.blur', 'country');
                }, 300);
            }

            /**
             * Handle with existing text1
             * @param {string} text1 
             */
            function _handleWithExistingText1(text1) {
                if (!checkoutProcessCtrl.isAddressVerificationEnabled) {
                    return;
                }
                if (!checkoutProcessCtrl.addressDetails.hasHouseNumberAndRoute) {
                    checkoutProcessCtrl.addressDetails.isDisabledAddressField = true;
                    return;
                }
                var city = extractAddressField('city');
                if (city) {
                    // Validate text1
                    var address = text1 + ', ' + city;
                    var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.text1, address, checkoutProcessCtrl.suggestedAddresses);
                    if (!isExisted) {
                        $rootScope.$emit('checkout.address.delivery.setFormError', 'text1');
                    }
                } else {
                    // Auto fill city from text1
                    var suggestion = checkoutProcessCtrl.suggestedAddresses.find(function (item) {
                        return item.mainValue && item.mainValue.toLowerCase() === text1.toLowerCase();
                    });
                    if (suggestion) {
                        onAddressChosen({ option: suggestion });
                    } else {
                        $rootScope.$emit('checkout.address.delivery.setFormError', 'text1');
                    }
                }
                $rootScope.$emit('checkout.details.location.blur', 'text1');
            }

            function _handleWithEmptyText1() {
                if (!checkoutProcessCtrl.addressDetails.hasHouseNumberAndRoute) {
                    $scope.addressForm['addressText'].$setValidity('required', false);
                    checkoutAddressCtrl.showErrors = true;
                }
            }

            /**
             * Set value for address field
             * @param {string} field 
             * @param {any} value 
             * @param {any} initialValue 
             */
            function _setOrInitValueForAddressField(field, value, initialValue) {
                var isDefined = angular.isDefined(checkoutProcessCtrl.addressDetails[field]);
                checkoutProcessCtrl.addressDetails[field] = isDefined ? value : initialValue;
            }

            /**
             * Edit unrecognized address
             */
            function editUnrecognizedAddress() {
                if (!checkoutProcessCtrl.addressDetails.isDisabledAddressField) {
                    return;
                }
                var text1InputRef = document.getElementById('address_input');
                if (text1InputRef) {
                    checkoutProcessCtrl.addressDetails.isDisabledAddressField = false;
                    $timeout(function () {
                        text1InputRef.focus();
                    }, 0);
                }
            }

            _listeners.push($rootScope.$on('checkout.address.delivery.setFormError', _setFormErrorEvent));
            _listeners.push($rootScope.$on('checkout.address.delivery.hideFormError', _hideFormErrorEvent));
            _listeners.push($rootScope.$on('checkout.address.delivery.blurInput', _triggerInputBlur));
            _listeners.push($rootScope.$on('checkout.details.location.blur', _handleOnLocationBlur));
        }]);
})(angular);
